import React, { useCallback, useState,useEffect } from "react";
import WithSidebar from "../../../../templates/withSidebar";
import {
    Row,
    Col,
    Space,
    Form,
    Input,
    Button,
    Breadcrumb,
    theme,
    Divider,
    Select,
} from "antd";
import {
    REGION_GROUP,
    DATA_MASTER_DATA_TYPE,
    VOC_MASTER_DATA_TYPE,
    OTHER_BUSINESS_EXPECT,
    PRODUCT_REQUIREMENT,
    OTHER_PRODUCT_EXPECT,
    OTHER_SUPPORT_EXPECT,
    CUSTOMER_SUPPORT,
    CUSTOMER_EXPECT,
    BUSINESS_REQUIRE,
    SUCCESS_CODE,

} from "../../../../lib/const";
import {
  ArrowLeftOutlined,
} from "@ant-design/icons";
import useMasterData from "../../../../lib/hooks/useMasterData";
import Heading from "../../../../components/common/heading";
import useCancelModal from "../../../../lib/hooks/useCancelModal";
import { routes } from "../../../../routes";
import FailModal from "../../../../components/modal/failModal";
import SuccessModal from "../../../../components/modal/successModal";
import CustomerCompetitorAdd from "../components/add";
import {createCompetitor,getCompetitorById,updateCustomerCompetitor} from "../../../../services/customerOfCompetitor"
import { useNavigate, useLocation } from "react-router-dom";

const { useToken } = theme;
const { Option } = Select;

export const AddCustomerCompetitorInternational = () => {
    const { token } = useToken();
    const [form] = Form.useForm();
    const location = useLocation();
    const [dataDetail,setDataDetail] = useState();
    const [id, setId] = useState(location.state.id ? location.state.id : "");
    const [actionType, setActionType] = useState(
        location.state.action_type ? location.state.action_type : ""
    );
    const [actionName, setActionName] = useState("เพิ่มสิทธิ์");
    const { setOpenCancelModal, setPreviousPage } = useCancelModal();
    const [regionGroup] = useMasterData(DATA_MASTER_DATA_TYPE, REGION_GROUP);
    const [failModal, setFailModal] = useState(false);
    const [successModal, setSuccessModal] = useState(false);
    const navigate = useNavigate();
    
    const [productRequirement] = useMasterData(
        VOC_MASTER_DATA_TYPE,
        PRODUCT_REQUIREMENT
    );
    const [otherBusinessExpect] = useMasterData(
        VOC_MASTER_DATA_TYPE,
        OTHER_BUSINESS_EXPECT
    );
    const [otherProductExpect] = useMasterData(
        VOC_MASTER_DATA_TYPE,
        OTHER_PRODUCT_EXPECT
    );
    const [otherSupportExpect] = useMasterData(
        VOC_MASTER_DATA_TYPE,
        OTHER_SUPPORT_EXPECT
    );
    const [customerSupport] = useMasterData(
        VOC_MASTER_DATA_TYPE,
        CUSTOMER_SUPPORT
    );
      const [customerExpect] = useMasterData(
        VOC_MASTER_DATA_TYPE,
        CUSTOMER_EXPECT
    );
    const [businessRequire] = useMasterData(
        VOC_MASTER_DATA_TYPE,
        BUSINESS_REQUIRE
    );
    const getDetail = useCallback(async () => {
        const res = await getCompetitorById(id,"international");
        if (res.data.code === "0000") {
            let result_data = res.data.objectValue;
            
            setDataDetail(result_data);
            setActionName("แก้ไขข้อมูล");
            
            
            form.setFieldsValue({
            factoryNameTh : result_data?.factoryNameTh,
            factoryNameEn : result_data?.factoryNameEn,
            customerGroupByRegion : result_data?.customerGroupByRegion,
            customerRegion : result_data?.customerRegion,
            productAndServiceWant : result_data?.productAndServiceWant,
            productAndServiceExpected : result_data.productAndServiceExpected[0] != "" ? result_data.productAndServiceExpected : undefined,
            supportWant : result_data?.supportWant,
            supportExpected : result_data.supportExpected[0] != "" ? result_data.supportExpected : undefined,
            transactionWant : result_data?.transactionWant,
            transactionExpected : result_data.transactionExpected[0] != "" ? result_data.transactionExpected : undefined,
            crmExpected : result_data?.crmExpected,
            productAndServiceSuggestion : result_data?.productAndServiceSuggestion ,
            supportSuggestion : result_data?.supportSuggestion ,
            transactionSuggestion : result_data?.transactionSuggestion ,
            crmSuggestion : result_data?.crmSuggestion ,
            notSatisfied : result_data?.notSatisfied ,
            });
        }
    });
    useEffect(() => {
        if (actionType === "EDIT") {
        setActionName("แก้ไขข้อมูล");

        getDetail();
        } else {
        setActionName("เพิ่มข้อมูล");
        form.resetFields();
        }
    },[location]);
    //create&Edit
    const onFinish = async  (values) => {
        if (actionType === "CREATE") {
        const request = {
            customerCompetitorId : id,
            factoryNameTh : values?.factoryNameTh || "",
            factoryNameEn : values?.factoryNameEn || "",
            competitorType : "international",
            customerGroupByRegion : values?.customerGroupByRegion || [],
            customerRegion : values?.customerRegion || "",
            productAndServiceWant : values?.productAndServiceWant || [],
            productAndServiceExpected : values?.productAndServiceExpected || [],
            supportWant : values?.supportWant || [],
            supportExpected : values?.supportExpected || [],
            transactionWant : values?.transactionWant || [],
            transactionExpected : values?.transactionExpected || [],
            crmExpected : values?.crmExpected || [],
            productAndServiceSuggestion : values?.productAndServiceSuggestion || "",
            supportSuggestion : values?.supportSuggestion || "",
            transactionSuggestion : values?.transactionSuggestion || "",
            crmSuggestion : values?.crmSuggestion || "",
            notSatisfied : values?.notSatisfied || "",
        }
        // createCompetitorinternational(request)
        const res = await createCompetitor(request);
        if (res.data.code === SUCCESS_CODE) {
            setSuccessModal(true);
            setTimeout(() => {
            navigate(routes.customer_tab_customercompetitor_international);
            setSuccessModal(false);
            }, 2000);
        } else {
            setFailModal(true);
            setTimeout(() => {
            setFailModal(false);
            }, 2000);
        }
    }
    //Edit
    else{
        const request = {
            customerCompetitorId : id,
            factoryNameTh : values?.factoryNameTh || "",
            factoryNameEn : values?.factoryNameEn || "",
            competitorType : "international",
            customerGroupByRegion : values?.customerGroupByRegion || [],
            customerRegion : values?.customerRegion || "",
            productAndServiceWant : values?.productAndServiceWant || [],
            productAndServiceExpected : values?.productAndServiceExpected || [],
            supportWant : values?.supportWant || [],
            supportExpected : values?.supportExpected || [],
            transactionWant : values?.transactionWant || [],
            transactionExpected : values?.transactionExpected || [],
            crmExpected : values?.crmExpected || [],
            productAndServiceSuggestion : values?.productAndServiceSuggestion || "",
            supportSuggestion : values?.supportSuggestion || "",
            transactionSuggestion : values?.transactionSuggestion || "",
            crmSuggestion : values?.crmSuggestion || "",
            notSatisfied : values?.notSatisfied || "",
        }

        // EditCompetitorinternational(request)
        const res = await updateCustomerCompetitor(request);
        if (res.data.code === SUCCESS_CODE) {
            setSuccessModal(true);
            setTimeout(() => {
            navigate(routes.customer_tab_customercompetitor_international);
            setSuccessModal(false);
            }, 2000);
        } else {
            setFailModal(true);
            setTimeout(() => {
            setFailModal(false);
            }, 2000);
        }
    }
    };
    return (
        <WithSidebar>
            <div>
                <Row gutter={[24, 24]} style={{ marginTop: 15 }}>
                    <Col span={24}>
                        <div className="flex items-center">
                            <Space size={12}>
                                <Button
                                type="link"
                                onClick={() => {
                                    setOpenCancelModal(true);
                                    setPreviousPage(routes.customer_tab_customercompetitor);
                                }}
                                style={{ padding: 0 }}
                                >
                                <ArrowLeftOutlined style={{ color: "#000", fontSize: 16 }} />
                                </Button>
                                <Heading text={"เพิ่มข้อมูล"} size={4} style={{ margin: 0 }} />
                            </Space>
                        </div>
                        <Breadcrumb
                        style={{ paddingTop: 10 }}
                        items={[
                            {
                            title: "คลังข้อมูลลูกค้าของคู่แข่งต่างประเทศ",
                            },
                            {
                            title: <span className="pr_green">เพิ่มข้อมูล</span>,
                            },
                        ]}
                        />
                    </Col>
                    <Col span={24}>
                        <Form
                            form={form}
                            onFinish={onFinish}
                            layout="vertical"
                            autoComplete="off"
                            style={{ width: "100%", padding: "0 30px" }}
                        >
                            <Row gutter={[24, 16]} style={{ marginBottom: 10 }}>
                                <Col span={24} align="right">
                                    <Space>
                                    <Button
                                        onClick={() => {
                                        setOpenCancelModal(true);
                                        setPreviousPage(routes.customer_tab_customercompetitor_international);
                                        }}
                                    >
                                        ยกเลิก
                                    </Button>
                                    <Button type="primary" htmlType="submit">
                                        บันทึก
                                    </Button>
                                    </Space>
                                </Col>
                            </Row>
                            <CustomerCompetitorAdd
                            header={"ข้อมูลลูกค้าของคู่แข่งต่างประเทศ"}
                            regionGroup ={regionGroup}
                            productRequirement ={productRequirement}
                            otherProductExpect ={otherProductExpect}
                            customerSupport ={customerSupport}
                            otherSupportExpect ={otherSupportExpect}
                            businessRequire ={businessRequire}
                            otherBusinessExpect ={otherBusinessExpect}
                            customerExpect ={customerExpect}
                            />
                        </Form>
                    </Col>
                </Row>
            </div>
            <SuccessModal
                open={successModal}
                setOpen={setSuccessModal}
                title={"สำเร็จ"}
                subTitle={"ทำรายการสำเร็จ"}
            />
            <FailModal open={failModal} setOpen={setFailModal} />
        </WithSidebar>

    );
};

